export default __webpack_public_path__ + "static/media/PocketFic.c158aa14.png";